/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import Select from 'react-select';

export interface IDropdownProps {
    id: string;
    name: string;
    className?: string;
    value: string | number;
    additionalAddributes?: object;
    displayData: { key?: string | number; value?: string }[];
    isDisabled: boolean;
    onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
}

/**
 * Address dropdown.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const DropdownWithSearch: React.FC<IDropdownProps> = (props: IDropdownProps) => {
    const { id: itemId, name, className, value, additionalAddributes, displayData, isDisabled, onChange } = props;

    const options =
        displayData &&
        displayData.map(item => {
            return { value: item.key!.toString(), label: item.value! };
        });
    const onSelectChange = (value: any) => {
        const targetValue = value && value.value !== null && value.value !== undefined ? value.value : value;
        const manualEvent: any = { target: { value: targetValue, name: name } };
        onChange(manualEvent);
    };

    const selectStyles = {
        control: (provided: any) => ({ ...provided, minHeight: 48 })
    };

    return (
        <>
            <Select
                id={itemId}
                className={`${className}__dropdown custom-search-dropdown`}
                name={name}
                value={options.filter(option => option.value === value)}
                styles={selectStyles}
                ///@ts-ignore
                options={options}
                placeholder='Select your zone'
                onChange={onSelectChange}
                menuPlacement={'top'}
                maxMenuHeight={200}
                isDisabled={isDisabled}
                {...(additionalAddributes || {})}
            />
        </>
    );
};

export default DropdownWithSearch;
